
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('common-file-double')]),_c('path',{staticClass:"a",attrs:{"d":"M17.625,23.25H4.125a1.5,1.5,0,0,1-1.5-1.5V5.625"}}),_c('path',{staticClass:"a",attrs:{"d":"M21.375,18.159A1.8,1.8,0,0,1,19.625,20H7.375a1.8,1.8,0,0,1-1.75-1.841V2.591A1.8,1.8,0,0,1,7.375.75h8.9a1.711,1.711,0,0,1,1.238.539l3.349,3.524a1.888,1.888,0,0,1,.513,1.3Z"}})])])
          )
        }
      }
    